import { getRequest } from '..';

export function getAll() {
  return getRequest('/location');
}
